import {Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation} from '@angular/core';
import { Question } from '../../../models/question.model';
import { Answer } from '../../../models/answer.model';

@Component({
  selector: 'app-radio',
  templateUrl: './radio.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./radio.component.less']
})
export class RadioComponent implements OnInit {
  @Input() class!: string;
  @Input() question!: Question;
  @Input() answers!: Answer[];
  @Input() disabled!: boolean;
  @Output() answerSelected = new EventEmitter<(number | null)[]>();
  selectedAnswer!: number;
  selectedAnswers: (number | null)[] = [];

  constructor() { }

  ngOnInit(): void {
  }

  onAnswerChange(): void {
    this.answers.forEach((answer) => answer.selected = false);

    this.answerSelected.emit(this.selectedAnswers);
    const selectedAnswer = this.answers.find((answer) => answer.id === this.selectedAnswer);

    if (selectedAnswer) selectedAnswer.selected = true;

    this.selectedAnswers = this.answers.filter((answer) => answer.selected).map((answer) => answer.id);
    this.answerSelected.emit(this.selectedAnswers);
  }
}
